import {
    ADD_PROPERTY, UPDATE_PROPERTY, DELETE_PROPERTY, LOAD_PROPERTIES_UNITS_TENANTS
} from './actionTypes';


const addProperty = ({propertyName, numUnits, city, address, waterRate, electricityRate, mpesaShortcode,
    mpesaShortcodeType, tillNumber, penaltyType, fixedPenaltyAmount, percentagePenaltyAmount, automaticallyPenalize,
    penaltyDayOfMonth, managementFeeType, managementFeeFixedAmount, managementFeePercentage, taxRate, otherRecurringBillsItems,
    notes, companyName, paymentInstructions, managementInvoices
}) => ({
    type: ADD_PROPERTY,
    payload: {
        propertyName,
        numUnits,
        city,
        address,
        waterRate,
        electricityRate,
        mpesaShortcode,
        mpesaShortcodeType,
        tillNumber,
        penaltyType,
        fixedPenaltyAmount,
        percentagePenaltyAmount,
        automaticallyPenalize,
        penaltyDayOfMonth,
        managementFeeType,
        managementFeeFixedAmount,
        managementFeePercentage,
        taxRate,
        otherRecurringBillsItems,
        notes,
        companyName,
        paymentInstructions,
        managementInvoices
    },
    errors: null
});


const updateProperty = ({propertyId, propertyName, numUnits, city, address, waterRate, electricityRate,
    mpesaShortcode, mpesaShortcodeType, tillNumber, penaltyType, fixedPenaltyAmount, percentagePenaltyAmount,
    automaticallyPenalize, penaltyDayOfMonth, managementFeeType, managementFeeFixedAmount, managementFeePercentage,
    taxRate, otherRecurringBillsItems, notes, companyName, paymentInstructions, managementInvoices
}) => ({
    type: UPDATE_PROPERTY,
    payload: {
        propertyId,
        propertyName,
        numUnits,
        city,
        address,
        waterRate,
        electricityRate,
        mpesaShortcode,
        mpesaShortcodeType,
        tillNumber,
        penaltyType,
        fixedPenaltyAmount,
        percentagePenaltyAmount,
        automaticallyPenalize,
        penaltyDayOfMonth,
        managementFeeType,
        managementFeeFixedAmount,
        managementFeePercentage,
        taxRate,
        otherRecurringBillsItems,
        notes,
        companyName,
        paymentInstructions,
        managementInvoices
    },
    errors: null
});

const deleteProperty = (propertyId) => ({
    type: DELETE_PROPERTY,
    payload: {
        propertyId
    },
    errors: null
});

const fetchPropertiesUnitsTenants = () => ({
    type: LOAD_PROPERTIES_UNITS_TENANTS,
    payload: {

    }
})

export {
    addProperty, updateProperty, deleteProperty, fetchPropertiesUnitsTenants
};